// extracted by mini-css-extract-plugin
export default {"board":"boardHome_board__yVsyM","textHead":"boardHome_textHead__Nod43"};